import _pt from 'prop-types';
import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../hooks/useDocumentsAppConfigs.js";
import { Row, Col } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import AnnotationField from "../stores/AnnotationField.js";
import "../types/index.js";
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import PdfWrapper from "../components/PdfWrapper.js";
import FillablePdf from "./FillablePdf.js";
import LayoutWrapper from "../components/LayoutWrapper.js";
import FillableFieldProperties from "../components/annotation/fillable/FillableFieldProperties.js";
import MainContainer from "../components/MainContainer.js";
import useGetDocument from "../hooks/api/useGetDocument.js";
import FillableHeader from "../components/FillableHeader.js";

var FillableDocument = function FillableDocument(_ref) {
  var documentId = _ref.documentId,
      pageTitle = _ref.pageTitle,
      pdfTitle = _ref.pdfTitle,
      highlightUnassignedFields = _ref.highlightUnassignedFields,
      submitFormButtonText = _ref.submitFormButtonText,
      successModalHeaderText = _ref.successModalHeaderText,
      SuccessModalBody = _ref.successModalBody,
      SuccessModalRedirectButton = _ref.successModalRedirectButton,
      signatureModalSize = _ref.signatureModalSize,
      uneditableIfSigned = _ref.uneditableIfSigned,
      onSubmit = _ref.onSubmit,
      headerButtons = _ref.headerButtons,
      onSecondaryLinkClick = _ref.onSecondaryLinkClick,
      secondaryLinkText = _ref.secondaryLinkText;

  var _useGetDocument = useGetDocument(documentId),
      documentResource = _useGetDocument.documentResource,
      annotationFields = _useGetDocument.annotationFields;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  useEffect(function () {
    pdfStore.setHighlightUnassignedFields(highlightUnassignedFields);
  }, [pdfStore, highlightUnassignedFields]);
  useEffect(function () {
    if (documentResource) {
      pdfStore.setDocumentParties(documentResource.parties);
      var currentParty = documentResource.parties.find(function (party) {
        return party.userId === currentUserId || currentUserPermissions && party.permission && currentUserPermissions.includes(party.permission);
      });

      if (!currentParty) {
        throw new Error('Current user does not have access to this document');
      }

      pdfStore.setDocumentSubmitted(!!currentParty.submittedAt);
    }
  }, [pdfStore, documentResource, currentUserId, currentUserPermissions]);
  useEffect(function () {
    if (uneditableIfSigned) {
      var signedFields = AnnotationField.groupFieldsByDataType(annotationFields, undefined, undefined, true).signing.filter(function (field) {
        return !field.belongsTo(currentUserId, currentUserPermissions);
      });
      pdfStore.setSignableOnly(!!signedFields.length);
    }
  });
  return jsx(LayoutWrapper, null, jsx(FillableHeader, {
    documentId: documentId,
    pageTitle: pageTitle,
    pdfTitle: pdfTitle,
    fillableName: documentResource === null || documentResource === void 0 ? void 0 : documentResource.name,
    submitFormButtonText: submitFormButtonText,
    onSubmit: onSubmit,
    headerButtons: headerButtons,
    onSecondaryLinkClick: onSecondaryLinkClick,
    secondaryLinkText: secondaryLinkText
  }), jsx(MainContainer, null, jsx(Row, {
    className: "d-block d-sm-none"
  }, jsx(Col, {
    sm: 4,
    md: 3,
    className: "mb-4"
  }, jsx(FillableFieldProperties, null))), jsx(Row, {
    className: "flex-grow-1 overflow-hidden" // Workaround for a Safari bug: https://github.com/philipwalton/flexbugs/issues/197
    ,
    style: {
      flex: 1
    }
  }, jsx(Col, {
    sm: 4,
    md: 3,
    className: "mb-4 d-none d-sm-block"
  }, jsx(FillableFieldProperties, null)), jsx(Col, {
    className: "d-flex flex-column h-100",
    sm: 8,
    md: 9
  }, jsx(PdfWrapper, null, documentResource && annotationFields && jsx(FillablePdf, {
    pdfFileLink: documentResource.links.file,
    annotationFields: annotationFields,
    successModalHeaderText: successModalHeaderText,
    successModalBody: SuccessModalBody,
    successModalRedirectButton: SuccessModalRedirectButton,
    signatureModalSize: signatureModalSize
  }))))));
};

FillableDocument.displayName = "FillableDocument";
FillableDocument.propTypes = {
  documentId: _pt.string.isRequired,
  pageTitle: _pt.string.isRequired,
  pdfTitle: _pt.string,
  highlightUnassignedFields: _pt.bool.isRequired,
  submitFormButtonText: _pt.string.isRequired,
  successModalHeaderText: _pt.string,
  signatureModalSize: _pt.string,
  uneditableIfSigned: _pt.bool,
  onSubmit: _pt.func,
  onSecondaryLinkClick: _pt.func,
  secondaryLinkText: _pt.string,
  children: _pt.node
};
var FillableDocument$1 = withStores(observer(FillableDocument));
export default FillableDocument$1;